import { ApolloProvider } from '@apollo/react-hooks'
import ApolloClient, { InMemoryCache } from 'apollo-boost'
import React, { useEffect } from 'react'
import TagManager from 'react-gtm-module'
import { withRouter } from 'react-router-dom'
import '../node_modules/react-modal-video/css/modal-video.min.css'
import './App.css'
import { withFirebase } from './components/Firebase'
import { LOGIN_VIEW, OTP_VIEW } from './resources/appRoutes'
import routes, { publicRoutes } from './routes'
// import BottomPanel from './components/BottomPanel'
import { ViewContainer } from './theme'
import { clarity } from 'react-microsoft-clarity'

const tagManagerArgs = {
  gtmId: 'GTM-NX57ZQT',
}

const graphqlClient = new ApolloClient({
  // uri: ` https://iz0qdobaql.execute-api.ap-south-1.amazonaws.com/develop/graphql`,
  uri: `${process.env.REACT_APP_BACKEND_SERVER}/graphql`,
  cache: new InMemoryCache(),
  // request: operation => {
  //   let token
  //   firebase.auth().onAuthStateChanged(async user => {
  //     if (user) {
  //       token = await firebase.auth().currentUser.getIdToken()
  //       localStorage.setItem('accessToken', token)
  //     } else {
  //       token = ''
  //     }
  //   })
  //   operation.setContext({
  //     headers: {
  //       authorization: `Bearer ${token}`,
  //     },
  //   })
  // },
})

function App(props) {
  const userAge = localStorage.getItem('age')
  useEffect(() => {
    props.firebase.auth.onAuthStateChanged((user) => {
      if (!user) {
        if (
          props.location.pathname !== OTP_VIEW &&
          !!localStorage.getItem('understood')
        ) {
          props.history.push(LOGIN_VIEW)
        }
      }
    })
    clarity.init('eboff7xq0b')
  }, [props.location.pathname])

  const sendProfileClickEvent = function () {
    window.sendEvent({
      type: 'Profile Click',
      data: { userId: localStorage.getItem('id') },
    })
  }

  const { firebase } = props

  return (
    <ApolloProvider client={graphqlClient}>
      {/* {props.location.pathname !== LOGIN_VIEW &&
        props.location.pathname !== ONBOARDING_VIEW &&
        props.location.pathname !== LEGAL_VIEW &&
        props.location.pathname !== OTP_VIEW &&
        props.location.pathname !== CHILD_AGE_VIEW &&
        props.location.pathname !== ONBOARD_REWARDS &&
        // props.location.pathname !== PRIVATE_POLICY_VIEW &&
        props.location.pathname !== EDIT_PROFILE_VIEW &&
        props.location.pathname !== JOURNEY_VIEW &&
        props.location.pathname !== QUIZ_VIEW &&
        props.location.pathname !== VIDEOS_VIEW &&
        props.location.pathname !== POINTS_AWARD_VIEW &&
        props.location.pathname !== CERTIFICATE_VIEW &&
        props.location.pathname !== LEADERBOARD_VIEW &&
        props.location.pathname !== WORKSHEET_VIEW &&
        props.location.pathname !== WORKSHEETQUIZ_VIEW &&
        props.location.pathname !== FAMILY_PROGRESS_VIEW &&
        props.location.pathname !==HOW_TO_WIN_VIEW && 
        props.location.pathname !==KID_ASSESSSMENT_VIEW && 
        props.location.pathname !==PARENT_SCREENER_VIEW && 
        (
          <TopPanel
            view={props.location.pathname}
            onProfileClick={() => {
              sendProfileClickEvent()
              props.history.push(PROFILE_VIEW)
            }}
            onLogoClick={() => {props.history.push(HOME_VIEW) 
              window.sendEvent({
              type: 'HS_HEADER_TP_LOGO',
              data: { userId: localStorage.getItem('id') },
            })} }
          />
        )} */}

      {/* Align items space-between and justify conetent center */}
      <ViewContainer className="d-flex flex-column flex-grow-1  overflow-auto view-container">
        {!!localStorage.getItem('id')
          ? routes(firebase, userAge)
          : publicRoutes(firebase, !!localStorage.getItem('understood'))}
      </ViewContainer>

      {/* {props.location.pathname !== LOGIN_VIEW &&
        props.location.pathname !== OTP_VIEW &&
        props.location.pathname !== LEGAL_VIEW &&
        props.location.pathname !== ONBOARDING_VIEW && (
          <BottomPanel
            path={props.location.pathname}
            routeTo={props.history.push}
          />
        )} */}
    </ApolloProvider>
  )
}

TagManager.initialize(tagManagerArgs)

export default withRouter(withFirebase(App))
